(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('DataElementDialogController', DataElementDialogController);

    DataElementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DataElement', 'Element', 'Formulaire', 'AutreActivite'];

    function DataElementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DataElement, Element, Formulaire, AutreActivite) {
        var vm = this;

        vm.dataElement = entity;
        vm.clear = clear;
        vm.save = save;
        vm.elements = Element.query();
        vm.formulaires = Formulaire.query();
        vm.autreactivites = AutreActivite.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dataElement.id !== null) {
                DataElement.update(vm.dataElement, onSaveSuccess, onSaveError);
            } else {
                DataElement.save(vm.dataElement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bhsApp:dataElementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
